import { object } from '@iwentsourcing/core/typing/object.js';
import { string } from '@iwentsourcing/core/typing/string.js';

export const AuthorizeRequest = object('AuthorizeRequest', {
  tenant: string(),
  realm: string(),
  provider: string(),
  code: string(),
  redirectUri: string(),
});
